





















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Brand, VehicleType, vehicleTypes} from '@/modules/neovehicle/models';
import {DncFamilyFilter, DncFamilyGroupFilter} from '@/modules/neovehicle/models/filters';
import debounce from 'lodash/debounce';
import {v4 as uuidv4} from 'uuid';
import {DncFamily, DncFamilyGroup} from '@/modules/neovehicle/models/dnc';

@Component
export default class extends Vue {
  @Prop({ type: Array, required: true })
  public data: DncFamilyGroup[];

  @Prop({ type: Boolean, required: true })
  public loading: boolean;

  @Prop({type: Array})
  public brands: Brand[];

  @Prop({ type: Object, required: true })
  public filter: DncFamilyGroupFilter;

  public pagination = {
    sortBy: 'id',
    descending: false,
  };

  public headers = [
    {text: 'Código', value: 'id', sortable: true, width: 150, show: true},
    {text: 'Bandeira', value: 'brandname', show: true},
    {text: 'Dnc Família Grupo', value: 'name', show: true},
    {text: 'Quantidade de Famílias', value: 'families', show: true},
    {text: '', value: '', sortable: false, width: 50, show: true},
  ];

  public changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  public get handleSearch() {
    return debounce(() => {
      this.$emit('search');
    }, 1000);
  }

  public handleEdit(family: DncFamily) {
    this.$emit('edit', family);
  }

  public handleCreate() {
    this.$emit('create');
  }
}
